<template>
  <div id="keyword-page">
    <page-header-component icon="bi bi-key" title="Kata Kunci" :hide-filter="true" />
    <tab-vertical-component :tabs="tabs" :actived="default_tab" v-if="tipe_project == 1" />
    <keyword-kabayan v-else />
    <v-tour v-if="tour_steps.length > 0" name="myTour" :steps="tour_steps" :options="{ highlight: true }"></v-tour>
  </div>
</template>

<script>
import tab_vertical from "@/views/components/tab_vertical.vue";
import page_header from "@/views/components/page_header.vue";
import keyword_kabayan from "@/views/pages/settings/KeywordKabayan.vue";
import tab_media_konvensional from "@/views/components/settings/keyword/tab_media_konvensional.vue";
import tab_media_sosial from "@/views/components/settings/keyword/tab_media_sosial.vue";
import tab_facebook_fanpage from "@/views/components/settings/keyword/tab_facebook_fanpage.vue";
import tab_instagram_hashtag from "@/views/components/settings/keyword/tab_instagram_hashtag.vue";
// import tab_review_aplikasi from "@/views/components/settings/keyword/tab_review_aplikasi.vue";
import tab_highlight_post from "@/views/components/settings/keyword/tab_highlight_post.vue";
// import tab_impor_ekspor from "@/views/components/settings/keyword/tab_impor_ekspor.vue";
import tab_pemberitahuan_integrasi from "@/views/components/settings/keyword/tab_pemberitahuan_integrasi.vue";

export default {
  name: "Keyword",
  title: "Pengaturan Kata Kunci | Sibernetik",
  components: {
    "page-header-component": page_header,
    "tab-vertical-component": tab_vertical,
    "keyword-kabayan": keyword_kabayan,
  },
  data() {
    return {
      currentModal: null,
      tipe_project: this.$store.getters.user.project.project_detail.tipe,
      tabs: [],
      display_tipe:
        this.$store.getters.user.project.project_detail.display_tipe,
      default_tab: 0,
      tour_steps: [],
    };
  },
  created: function () {
    if (this.display_tipe == 2 || this.display_tipe == 3) {
      this.tabs.push({
        name: "Media Online",
        icon_class: "bi bi-globe-americas",
        component: tab_media_konvensional,
      });
    }
    if (this.display_tipe == 1 || this.display_tipe == 3) {
      this.tabs.push(
        {
          name: "Media Sosial",
          icon_class: "bi bi-heart-fill",
          component: tab_media_sosial,
        },
        {
          name: "Halaman Facebook",
          icon_class: "bi bi-facebook",
          component: tab_facebook_fanpage,
        },
        {
          name: "Instagram Tagar",
          icon_class: "bi bi-instagram",
          component: tab_instagram_hashtag,
        },
        // {
        //   name: "Tinjauan Aplikasi",
        //   icon_class: "bi bi-phone",
        //   component: tab_review_aplikasi,
        // }
      );
    }
    this.tabs.push(
      // {
      //   name: "Impor/Ekspor",
      //   icon_class: "fa file-import",
      //   component: tab_impor_ekspor,
      //   data: 1,
      // },
      {
        name: "Postingan Sorotan",
        icon_class: "bi bi-globe-americas",
        component: tab_highlight_post,
      },
      {
        name: "Pemberitahuan dan Integrasi",
        icon_class: "bi bi-globe-americas",
        component: tab_pemberitahuan_integrasi,
      }
    );
    if ("keyword-active-sub-tab" in this.$route.query) {
      this.default_tab =
        parseInt(this.$route.query["keyword-active-sub-tab"]) < this.tabs.length
          ? parseInt(this.$route.query["keyword-active-sub-tab"])
          : 0;
    }
  },
};
</script>
